import authHelper from '@/helpers/auth';

const state = {
	isLoggedIn: !!authHelper.getAccessToken(),
	loginFailed: false,
	pending: false,
	lastError: {
		message: 'Foutje'
	},
	me: false
};

export default state;



// WEBPACK FOOTER //
// ./src/store/modules/auth/state.js